import { render, staticRenderFns } from "./Leistungen.vue?vue&type=template&id=1bffba77&scoped=true&"
import script from "./Leistungen.vue?vue&type=script&lang=js&"
export * from "./Leistungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bffba77",
  null
  
)

export default component.exports